/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-06-21 18:39:45
 *
 *******************************************************/

export const issuesChoices = [
  {
    label: 'AdminHTML.Installation.Constant.issuesChoices1_Label',
    value: 'brokenLayout',
    code: '2.1'
  },
  {
    label: 'AdminHTML.Installation.Constant.issuesChoices2_Label',
    value: 'filterTreeDisplay',
    code: '2.2'
  },
  {
    label: 'AdminHTML.Installation.Constant.issuesChoices3_Label',
    value: 'missingElements',
    code: '2.3'
  },
  {
    label: 'AdminHTML.Installation.Common.others',
    value: 'others',
    code: '2.4'
  }
];

export const customizeChoices = [
  {
    label: 'AdminHTML.Installation.Constant.customizeChoices1_Label',
    value: 'filter',
    code: '4.1'
  },
  {
    label: 'AdminHTML.Installation.Constant.customizeChoices2_Label',
    value: 'search',
    code: '4.2'
  },
  {
    label: 'AdminHTML.Installation.Constant.customizeChoices3_Label',
    value: 'sorting',
    code: '4.3'
  },
  {
    label: 'AdminHTML.Installation.Constant.customizeChoices4_Label',
    value: 'theme',
    code: '4.4'
  },
  {
    label: 'AdminHTML.Installation.Common.others',
    value: 'others',
    code: '4.5'
  }
];

export const customizeSelect = [
  {
    label: 'AdminHTML.Dashboard.Constant.customizeSelect_Option1',
    value: ''
  },
  {
    label: 'AdminHTML.Dashboard.Constant.customizeSelect_Option2',
    value: 'appUsage'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.customizeSelect_Option3',
    value: 'appIssue'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.customizeSelect_Option4',
    value: 'incorrectData'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.customizeSelect_Option5',
    value: 'appRequest'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.customizeSelect_Option6',
    value: 'others'
  }
];

export const requestCustomization = [
  {
    label: 'AdminHTML.Dashboard.Constant.requestCustomization_Option1',
    value: ''
  },
  {
    label: 'AdminHTML.Dashboard.Constant.requestCustomization_Option2',
    value: 'customRangeSlider'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.requestCustomization_Option3',
    value: 'customSorting'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.requestCustomization_Option4',
    value: 'filterByMetafields'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.requestCustomization_Option5',
    value: 'customFilterMatchTheTheme'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.requestCustomization_Option6',
    value: 'filterOnHomepage'
  },
  {
    label: 'AdminHTML.Dashboard.Constant.requestCustomization_Option7',
    value: 'others'
  }
];

export const featureReports = [
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.choice01',
    value: 'filters'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.choice02',
    value: 'search'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.choice03',
    value: 'recommendation'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.choice04',
    value: 'other'
  }
];
export const typeOfIssue = [
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.multiSelectValue01',
    value: 'incompatibleTheme'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.multiSelectValue02',
    value: 'missingFilterTrees'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.multiSelectValue03',
    value: 'missingProductItem'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.multiSelectValue04',
    value: 'missingSearchBar'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.multiSelectValue05',
    value: 'missingRecommendationWidgets'
  },
  {
    label: 'AdminHTML.DashboardV3.InstallStatusBanner.sendRequestModal.multiSelectValue06',
    value: 'requestCustomization'
  }
];
